module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0ce2c9db4c2d4b752e43b455d12ce5ed.png";